import { Box, Container, Typography } from "@mui/material";
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

function EarlyAccessConfirmation() {

    return (
        <Box display="flex"
            flexDirection={"column"}
            width="50vw" // Set width to 50% of the viewport width
            maxWidth="40%" alignItems={'center'}
            justifyContent={'center'}
            margin={'auto'}
            marginTop={12}
            padding={3}
            borderRadius={5}
            border="1px solid #e0e0e0">
            <Container>
                <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', height: 64, width: 64, borderRadius: '50%', backgroundColor: 'primary.light', margin: 'auto' }}>
                    <MarkEmailReadIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                </Box>
                <Typography variant='h2' padding={3} textAlign={'center'}>You're on the list!</Typography>

                <Typography variant="subtitle1" gutterBottom>Thank you for requesting early access! We'll send an email to you once your spot is ready. Please remember
                    to check your spam folder.</Typography>
            </Container>
        </Box>
    )
}

export default EarlyAccessConfirmation;